const situations = [
  'конфликт двух сильных сотрудников, каждый из которых считает себя правым;',
  'сотрудник конфликтует с руководителем и оспаривает его решения;',
  'руководитель избегает разговора с проблемным сотрудником;',
  'сотрудник систематически нарушает договорённости;',
  'отдел продаж конфликтует с производством из-за сроков и приоритетов;',
  'продажи конфликтуют с маркетингом по поводу лидов и их качества;',
  'сотрудники перекладывают ответственность друг на друга;',
  'руководитель считает сотрудника «токсичным», но не может сформулировать, в чём именно проблема;',
  'сотрудник считает требования руководителя несправедливыми;',
  'конфликт из-за KPI и распределения премий;',
  'конфликт из-за распределения клиентов между менеджерами;',
  'конфликт между опытным и новым сотрудником;',
  'сопротивление изменениям: новым процессам, структуре или регламентам;',
  'конфликт руководителей разных подразделений.',
];

export default function PracticalSituations() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Какие конфликты разбираем на тренинге
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Типовые рабочие ситуации, с которыми руководители сталкиваются регулярно. Реальные кейсы компании могут быть встроены в программу
        </p>

        <div className="grid sm:grid-cols-2 gap-3 max-w-4xl mx-auto">
          {situations.map((s, i) => (
            <div key={i} className="flex items-start gap-2.5 bg-white rounded-lg border border-gray-200 p-4 hover:border-teal-300 transition-colors">
              <i className="ri-flashlight-line text-teal-600 mt-0.5 flex-shrink-0"></i>
              <span className="text-sm text-gray-700 leading-relaxed">{s}</span>
            </div>
          ))}
        </div>

        <p className="text-center text-sm text-gray-500 mt-8 max-w-2xl mx-auto">
          Вместо абстрактных упражнений можно использовать ситуации, с которыми руководители сталкиваются непосредственно в своей работе: сложный сотрудник, конфликт между отделами, сопротивление изменениям, нарушение договорённостей.
        </p>
      </div>
    </section>
  );
}